export const CONNECT_EVENT = 'connect';
export const JOIN_ROOM_EVENT = 'joinRoom';
export const FROM_AI_EVENT = 'messageFromAI';
export const TO_AI_EVENT = 'messageToAI';

export const AI_SENDER = 'AI';
export const YOU_SENDER = 'You';

export const INCOMING = 'incoming';
export const OUTGOING = 'outgoing';

export const GATEWAY_PATH = '/nest/socket.io';

export const styles: { [key: string]: React.CSSProperties } = {
    widgetContainer: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: 1000,
    },
    chatBox: {
      width: "400px",
      height: "600px",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      backgroundColor: "#0078d4",
      color: "#fff",
      padding: "10px",
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    closeButton: {
      backgroundColor: "transparent",
      border: "none",
      color: "#fff",
      fontSize: "16px",
      cursor: "pointer",
    },
    openButton: {
      backgroundColor: "#0078d4",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      cursor: "pointer",
      fontSize: "16px",
    },
  };